import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { YearSelect, MonthSelect } from "../../../../helpers/ui/YearSelect";
import { accessRole } from "../../../../helpers/access_role";
import { Preview, generateFormData } from "../../../../helpers/ui/FileInput";
import Select from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import IndexBloc from "../Index/Blocs/IndexBloc";
import moment from "moment";

class DetailView extends Component {
  indexBloc = new IndexBloc();
  source;
  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      rankOption: [],
      signatoriesOption: [],
      detail: [],
      rankFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "rank_id",
          order: "asc",
        },
      },
      signatoriesFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "signatories_official_id",
          order: "asc",
        },
      },
      decree_cp3k_signatories_official_name: "",
      decree_cp3k_signatories_official_nip: "",
      decree_cp3k_adjustment_signatories_official_name: "",
      decree_cp3k_adjustment_signatories_official_nip: "",
    };
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  getMonthName = (input) => {
    let res = "-";
    if (input != null) {
      res = moment().month(parseInt(input)).locale("id-id").format("MMMM");
    }
    return res;
  };

  loadDetail = async () => {
    const query = {
      uuid: this.props.id,
    };
    await this.indexBloc.fetchDetail(query, this.source.token);
  };

  loadSignatoriesList = async () => {
    let offset =
      (this.state.signatoriesFilter.page_number - 1) *
      this.state.signatoriesFilter.page_size;
    const query = {
      search: this.state.signatoriesFilter.filter_value,
      limit: this.state.signatoriesFilter.page_size,
      offset: offset,
      order: this.state.signatoriesFilter.sort_order.column,
      sort: this.state.signatoriesFilter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchSignatories(query, this.source.token);
  };

  loadRankList = async () => {
    let offset =
      (this.state.rankFilter.page_number - 1) * this.state.rankFilter.page_size;
    const query = {
      search: this.state.rankFilter.filter_value,
      limit: this.state.rankFilter.page_size,
      offset: offset,
      order: this.state.rankFilter.sort_order.column,
      sort: this.state.rankFilter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchRankList(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadSignatoriesList();
    this.loadRankList();
    this.loadDetail();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.indexBloc.rankListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ rankOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.signatoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ signatoriesOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.detailChannel.subscribe((result) => {
      const data = result.data.response;
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            detail: data,
            decree_cp3k_signatories_official_name:
              data.decree_cp3k_signatories_official_name,
            decree_cp3k_signatories_official_nip:
              data.decree_cp3k_signatories_official_nip,
            decree_cp3k_adjustment_signatories_official_name:
              data.decree_cp3k_adjustment_signatories_official_name,
            decree_cp3k_adjustment_signatories_official_nip:
              data.decree_cp3k_adjustment_signatories_official_nip,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.rankListChannel?.unsubscribe();
    this.indexBloc.signatoriesChannel?.unsubscribe();
  }

  render() {
    const { detail } = this.state;
    const { result, total } = this.state.rankOption;
    const signatoriesResult = this.state.signatoriesOption?.result;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="skcp3k" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Detail SK Calon PPPK</CardTitle>
                  <hr />
                  <AvForm className="needs-validation">
                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Golongan Ruang <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.rank_group_room !== ""
                              ? this.state.detail.rank_group_room
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Nomor SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_number !== ""
                              ? this.state.detail.decree_cp3k_decree_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_date !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_decree_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        TMT SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_decree_tmt !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_decree_tmt
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "50%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Pejabat Penetap SK Calon PPPK</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          Nama Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_signatories_official_name !== ""
                                ? this.state.detail
                                    .decree_cp3k_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          NIP Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_signatories_official_nip !== ""
                                ? this.state.detail
                                    .decree_cp3k_signatories_official_nip
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2">
                        Masa Kerja Awal <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_year_period !== ""
                              ? this.state.detail.decree_cp3k_year_period +
                                " Tahun"
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_month_period !== ""
                              ? this.state.detail.decree_cp3k_month_period +
                                " Bulan"
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal Tugas <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_assignment_date !==
                            ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_assignment_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Nomor Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_nota_number !== ""
                              ? this.state.detail.decree_cp3k_nota_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2">
                        Tanggal Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.decree_cp3k_nota_date !== ""
                              ? this.dateParse(
                                  this.state.detail.decree_cp3k_nota_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "50%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Penyesuaian Masa Kerja</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          No. SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_number !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_decree_number
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          Tanggal SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="3">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_date !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .decree_cp3k_adjustment_decree_date
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          TMT SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="3">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_decree_tmt !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .decree_cp3k_adjustment_decree_tmt
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          Pejabat Penetap <span className="text-danger">*</span>
                        </Label>
                        <Col md="8">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_signatories_official_name !==
                              ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_signatories_official_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3">
                          Masa Kerja Awal <span className="text-danger">*</span>
                        </Label>
                        <Col md="2">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_year_period !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_year_period +
                                  " Tahun"
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="2">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .decree_cp3k_adjustment_month_period !== ""
                                ? this.state.detail
                                    .decree_cp3k_adjustment_month_period +
                                  " Bulan"
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 68, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2">File Pendukung</Label>
                      <Col md="6">
                        <Preview value={detail?.document} />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`/kepegawaian/home.html?skcp3k`}>
                          <Button color="danger" type="button">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        {/* <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button> */}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/home.html?skcp3k`} />
        ) : null}
      </Fragment>
    );
  }
}

export default DetailView;
